var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('span',{style:(_vm.metaStyle)},[_vm._v("\n  【大模型："+_vm._s(_vm.llmDurationSec)+"秒 | 语音合成："+_vm._s(_vm.ttsDurationSec)+"秒 | 输入tokens："+_vm._s(_vm.chat.llmInputTokens)+" | 输出tokens："+_vm._s(_vm.chat.llmOutputTokens)),(_vm.showTtsChars)?[_vm._v(" | 合成字符："+_vm._s(_vm.ttsChars))]:_vm._e(),_vm._v(" 】\n")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7775a2fb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rj-chat-llm-meta/RjChatLlmMeta.vue
// module id = null
// module chunks = 